import i18n from "i18next";

// Locale for user-visible date/number formatting, following the app language
// setting (react-i18next). Falls back to en-US before i18n init (SSR/tests).
export function getUserLocale(): "ko-KR" | "en-US" {
  return i18n.language?.startsWith("ko") ? "ko-KR" : "en-US";
}
